import { NavLink, useParams } from 'react-router-dom';
import clsx from 'clsx';
import { t } from '../i18n/es.js';
import { useUiStore } from '../state/uiStore.js';

export function Sidebar(): JSX.Element {
  const collapsed = useUiStore((s) => s.sidebarCollapsed);
  const { id } = useParams<{ id?: string }>();

  const items = [
    // P0: el item "Tenants" antiguo apuntaba a /tenants que solo redirige a /.
    // El Dashboard YA es la lista de tenants — un solo entry evita confusión.
    { to: '/', label: t.nav.tenants, end: true },
    ...(id
      ? [
          { to: `/tenants/${id}/channels`, label: t.nav.channels },
          { to: `/tenants/${id}/connectors`, label: t.nav.connectors },
          { to: `/tenants/${id}/templates`, label: t.nav.templates },
          { to: `/tenants/${id}/wa-flows`, label: 'WA Flows' },
          { to: `/tenants/${id}/wa-media`, label: 'WA Media' },
          { to: `/tenants/${id}/campaigns`, label: t.nav.campaigns },
          { to: `/tenants/${id}/surveys`, label: t.nav.surveys },
          { to: `/tenants/${id}/widgets`, label: t.nav.widgets },
          { to: `/tenants/${id}/users`, label: t.nav.users },
          { to: `/tenants/${id}/api-keys`, label: 'API Keys' },
          { to: `/tenants/${id}/variables`, label: 'Variables' },
          { to: `/tenants/${id}/flows`, label: t.nav.flows },
          { to: `/tenants/${id}/widget`, label: 'Widget preview' },
        ]
      : []),
  ];

  return (
    <aside
      className={clsx(
        'border-r border-slate-200 bg-white h-full transition-all',
        collapsed ? 'w-14' : 'w-56',
      )}
    >
      <nav className="flex flex-col gap-1 p-2">
        {items.map((it) => (
          <NavLink
            key={it.to}
            to={it.to}
            end={it.end}
            className={({ isActive }) =>
              clsx(
                'rounded px-3 py-2 text-sm',
                isActive
                  ? 'bg-brand-50 text-brand-700 font-medium'
                  : 'text-slate-700 hover:bg-slate-100',
              )
            }
          >
            {collapsed ? it.label.slice(0, 1) : it.label}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
